import ApiAcces from "@/shared/services/ApiAcces";
import type IUserPlanService from "../contracts/IUserPlanService";
import type AssignPlanRequest from "../models/AssignPlanRequest";
import type UserPlan from "../models/UserPlan";
import type { PlanStatus } from "../valueObjects/PlanStatus";

export default class UserPlanService extends ApiAcces implements IUserPlanService {
  async getUserPlan(userId: string): Promise<UserPlan | null> {
    try {
      return (await this.api.get(`/api/UserPlan/${userId}`)).data;
    } catch (err: any) {
      if (err?.status === 404) return null;
      throw err;
    }
  }

  async assignPlan(request: AssignPlanRequest): Promise<UserPlan> {
    return (await this.api.post("/api/UserPlan/assign", request)).data;
  }

  async updateStatus(userId: string, status: PlanStatus): Promise<void> {
    await this.api.patch(`/api/UserPlan/${userId}/status`, status);
  }
}
